function singletonMaker(key, klass) {
  if (!window.sparta) {
    window.sparta = {};
  }
  var KEY = Symbol.for(key);
  var globalSymbols = Object.getOwnPropertySymbols(sparta);
  var hasKey = globalSymbols.indexOf(KEY) > -1;
  if (!hasKey) {
    sparta[KEY] = new klass();
  }
  Object.seal(sparta[KEY]);
  return sparta[KEY];
}
export { singletonMaker as default };